import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { colors } from '@mui/material';

const PREFIX = 'OnlineIndicator';
const classes = {
    root: `${PREFIX}-root`,
    small: `${PREFIX}-small`,
    medium: `${PREFIX}-medium`,
    large: `${PREFIX}-large`,
    offline: `${PREFIX}-offline`,
    away: `${PREFIX}-away`,
    busy: `${PREFIX}-busy`,
    online: `${PREFIX}-online`,
};
const Root = styled('span')(({ theme }) => ({
    [`& .${classes.root}`]: {
        display: 'inline-block',
        borderRadius: '50%',
        flexGrow: 0,
        flexShrink: 0,
    },
    [`& .${classes.small}`]: {
        height: theme.spacing(1),
        width: theme.spacing(1),
    },
    [`& .${classes.medium}`]: {
        height: theme.spacing(2),
        width: theme.spacing(2),
    },
    [`& .${classes.large}`]: {
        height: theme.spacing(3),
        width: theme.spacing(3),
    },
    [`& .${classes.offline}`]: {
        backgroundColor: colors.grey[50],
    },
    [`& .${classes.away}`]: {
        backgroundColor: colors.orange[600],
    },
    [`& .${classes.busy}`]: {
        backgroundColor: colors.red[600],
    },
    [`& .${classes.online}`]: {
        backgroundColor: colors.green[600],
    },
}));
const OnlineIndicator = (_a) => {
    var { size = 'medium', status = 'offline', className } = _a, rest = __rest(_a, ["size", "status", "className"]);
    const rootClassName = clsx({
        [classes.root]: true,
        [classes[size]]: size,
        [classes[status]]: status,
    }, className);
    return jsx(Root, Object.assign({ className: rootClassName }, rest));
};

export { OnlineIndicator };
